import { Divider, Dropdown, Menu, MenuButton, MenuItem } from '@mui/joy';
import { FC, JSX, MouseEvent, useState } from 'react';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import IconButton from '@mui/joy/IconButton';
import { useNavigate } from 'react-router';
import { useToast } from '@consolidocs-ui/utils';
import { AlertModal } from '@consolidocs-ui/components';
import { useDeleteIndustryMutation } from '@consolidocs-ui/data-access/IndustryApi';

type Props = {
  industryId: string;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
};

export const RowMenu: FC<Props> = ({ industryId, onClick }): JSX.Element => {
  const navigate = useNavigate();
  const [triggerToast] = useToast();
  const [deleteIndustry, { isLoading: isDeleting }] =
    useDeleteIndustryMutation();
  const [openDeleteModal, setDeleteModal] = useState(false);

  const handleDeleteIndustry = async () => {
    try {
      await deleteIndustry(industryId).unwrap();
      triggerToast({ message: 'Industry Deleted', type: 'success' });
    } catch (err: unknown) {
      triggerToast({ message: 'Error Deleting Industry', type: 'danger' });
    }
    setDeleteModal(false);
  };

  return (
    <>
      <AlertModal
        alertAction={handleDeleteIndustry}
        alertActionText="Delete"
        alertCancelText="Cancel"
        alertMessage="Are you sure you want to delete this industry?"
        alertTitle="Delete Industry"
        isLoading={isDeleting}
        open={openDeleteModal}
        setOpen={setDeleteModal}
      />
      <Dropdown>
        <MenuButton
          slots={{ root: IconButton }}
          slotProps={{
            root: { variant: 'plain', color: 'neutral', size: 'sm' },
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClick?.(e);
          }}
        >
          <MoreHorizRoundedIcon />
        </MenuButton>
        <Menu size="sm" sx={{ minWidth: 140 }}>
          <MenuItem onClick={() => navigate(`/industries/edit/${industryId}`)}>
            Edit
          </MenuItem>
          <Divider />
          <MenuItem
            color="danger"
            onClick={(e) => {
              e.stopPropagation();
              setDeleteModal(true);
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </Dropdown>
    </>
  );
};
